export default {
  fr: {
    Global: {
        meta: {
            title: 'Momenta',
            description: '',
        },
        voice: {
  
            '0': "Eh bien, aucune hésitation !</br>Je ne savais pas que les humains étaient si courageux !",
            '1': "Hum, le sommeil m’a brouillé l’esprit et j’en perds mes souvenirs... J’aimerais me remémorer les œuvres à travers ton regard.",
            '2': "Il faut connaitre la galerie sur le bout de ses oreilles pour pouvoir mettre la main sur le <strong>portrait</strong> manquant.",
            '2:bis': "Veux-tu me décrire les <strong>œuvres</strong> autour de toi ? Choisis ta <strong>photographie</strong> préférée et clique dessus.",
            
            // 'explore:1

            // '3': "Observe bien le portrait. Décris-le ensuite à Enki en glissant trois mots de ton choix sur l’image.",
            '3': "Observe bien le portrait. Décris-le ensuite à Enki en glissant trois mots de ton choix sur l’image.",
            
            // 'defi1:1 => À toi de jouer. Choisis trois mots correspondants à cette œuvre.",
            
            '5': "J’aime bien ton regard sur ce portrait. Peux-tu essayer avec une autre œuvre qui pique ta curiosité ?",
            
            // 'explore:2
            // 'defi1:2 => À toi de jouer. Choisis trois mots correspondants à cette œuvre. 
            
            '6': "C’est intéressant de comprendre ta <strong>perception</strong> des œuvres.</br>Nous faisons une bonne équipe, toi et moi !",
            'use-tunnel': "J’aimerais te montrer une autre photographie.</br>Elle est cachée dans le grenier.",
            
            // 'secret': "[Le passage secret se révèle.]
            
            '8': "Emprunte ce passage secret pour la découvrir. C’est par là.</br>Ne crains rien, je suis avec toi !",
            
            // 'tunnel:1

            '9': "Tiens, tiens... J’ai laissé ici un de mes plus précieux objets.</br>Regarde sur le bureau.",
            
            // 'grenier:1 

            '10': "Voici mon <strong>codex</strong> magique. Il est rempli d’autocollants !",
            '11': "Certaines personnes aiment collectionner des timbres rares ou de jolis crayons; moi, je me passionne pour les autocollants.",
            '12': "J’aimerais te l’offrir, mon petit pois me dit que nous pourrions découvrir de nouveaux autocollants ensemble.",

            '13': "Mais revenons à nos boutons ! Il va falloir se remettre au travail</br>si l’on veut compléter la collection.",
            '13:1': "Je n’ai pas l’habitude de fréquenter les humains et j’aimerais comprendre leurs émotions.",
            '14': "Pourrais-tu m’expliquer ce que tu ressens quand tu regardes une œuvre ? Essayons avec ce drôle de portrait accroché dans le grenier.",

            // 'grenier:2

            '15': "Parmi les visages d’Enki, glisse celui qui représente l’émotion que tu ressens quand tu regardes cette œuvre.",
            
            // 'defi2:1 => Que ressens-tu devant ce portrait ?
            
            '16': "Oh, on dirait qu’il se passe quelque chose du côté du codex !</br>Je ne t’ai pas tout dit sur ce précieux <strong>artefact</strong>.",
            '17': "Lorsque tu prends le temps d’observer une œuvre, le codex l’analyse et crée un autocollant inspiré de celle-ci. C’est pas merveilleux ?",
            '18': "Utilisons le pouvoir du codex sur deux autres portraits. Retourne dans la galerie et choisis une œuvre qui te plait.",
            
            // 'tunnel:1 :
            
            '19': "J’adore jouer avec toi ! Découvrir tes émotions devant ces œuvres me permet de les voir autrement.",

            // 'explore:3
            // 'defi2:2 => Que ressens-tu devant ce portrait ?

            '20': "C’est passionnant, ce que tu m’exprimes ! Les humains sont vraiment mes créatures préférées !",

            // '[SÉPARATION] ?

            '21': "Ces portraits nous montrent à quel point les humains sont tous très différents. Ça m’impressionne à chaque fois !</br>Jouons ensemble à nouveau.",
            '22': "Cette fois-ci, choisis l’œuvre que tu trouves la plus étonnante.",

            // 'explore:4
            // 'defi2:3 => Que ressens-tu devant ce portrait ?

            '23': "J’apprends beaucoup grâce à toi et j’aimerais t’en dire</br>un peu plus à mon sujet.",
            '24': "C’est moi qui ai assemblé cette collection d’œuvres. J’ai toujours eu une fascination pour l’espèce humaine et je me suis alors lancé un défi...",
            '25': "Réunir des portraits pour mieux vous comprendre, vous, les humains.",

            // '[SÉPARATION] ?

            '26': "À vrai dire, la dernière œuvre, celle que nous voulons retrouver, n’existe pas. Enfin, pas encore ! Laisse-moi t’expliquer.",
            '27': "Les êtres humains sont si différents les uns des autres que je n’ai jamais su me décider sur le dernier portrait de ma collection.",

            '30' : "Avec ton aide, je vais pouvoir terminer mon travail. Puisque tu m’as prouvé que tu pouvais voir et ressentir les choses de manière unique, que dirais-tu de créer la dernière œuvre de la galerie ?",

            '31' : "Crée ton propre portrait : tu peux te représenter toi-même ou représenter quelqu’un d’autre.",
            '32' : "Utilise le codex pour sélectionner  les éléments de personnalisation inspirés des œuvres. Laisse aller ton imagination et surprend Enki avec ta création !",
            '33' : "Waouh, tu as beaucoup de talent !</br>Regarde comme ton œuvre est magnifique ! ",

            'merci' : "Bravo ! Tu m’as aidé à mieux vous comprendre, vous, les humains. T’avoir à mes côtés m’a été d’une aide précieuse, un grand merci !",
            '35' : "À moi maintenant de te faire découvrir les mystères de mon espèce. J’aimerais te faire don de la Vision des esprits.",

            // '36' : "Voici le monde tel que les esprits le voient ! Impressionnant, non ?",
            // '37' : "Ouf, quelle aventure ! [Enki bâille.] Notre quête est maintenant terminée, j'ai bien mérité un peu de repos. Avant de partir, prends le temps d'écouter les commentaires que j'ai glissés près des œuvres. Et reviens me voir quand tu veux, ma galerie est maintenant la tienne. Bon, c'est l'heure de la sieste…",
        
        },
        btn: {
            ok: 'Ok',
            deposer: 'Déposer',
            rendre: 'Rendre l’appareil à Nour',
            pickup: 'Ramasser',
            download: 'Télécharger',
            continue: 'Continuer',
            start_experience: "Commencer l'aventure",
            start: "Commencer",
            help: 'Aider Nour',
            skip: 'PASSER',
            completed: "J'ai terminé",
            listen: 'Écouter',
            read: 'Lire',
            close: 'Fermer',
            pause: 'Pause',
            world_call: 'WORLD 3D CALL OR NOT NEEDED',
            commentary: 'Commentaire'
        }
    }
  },
  en: {
    Global: {

      meta: {
        title: 'Momenta',
        description: '',
      },
      voice: {
              
            '0': "Well, no hesitation!</br>I didn’t know humans were so brave!",
            '1': "Hmm, sleep has clouded my mind and my memory’s foggy ... I’d like to remember the artworks through your eyes.",
            '2': "You have to know the gallery like the back of your brain if you’re going to lay your hands on the missing <strong>portrait</strong>.",
            '2:bis': "Can you describe to me the <strong>artworks</strong> around you? Choose your favourite <strong>photograph</strong> and click on it.",

            // 'explore:1

            '3': "Look closely at the portrait. Then describe it to Enki by choosing three words about the artwork and dragging them onto the image.",
            
            // 'defi1:1 => À toi de jouer. Choisis trois mots correspondants à cette œuvre.",
            
            '5': "I really like how you see this portrait. Can you try with another artwork that you’re curious about?",
            
            // 'explore:2
            // 'defi1:2 => À toi de jouer. Choisis trois mots correspondants à cette œuvre. 
            
            '6': "It’s interesting to understand your <strong>perception</strong> of artworks.</br>You and I, we make a good team!",
            'use-tunnel': "I’d like to show you another photograph.</br>It’s hidden in the attic.",
 
            // 'secret': "[Le passage secret se révèle.]
            
            '8': "Take this secret passage to find it. It’s through there.</br>Don’t be scared, I’m with you!",
            
            // 'tunnel:1

            '9': "Hey, wait ... I left one of my most precious objects here.</br>Look on the desk.",
            
            // 'grenier:1 

            '10': "Here’s my magical <strong>codex</strong>.</br>It’s full of stickers!",
            '11': "Some people like to collect rare stamps or pretty pencils;</br>I simply adore stickers.",
            '12': " I’d like to give it to you, my bean-brain tells me we’re going to discover new stickers together.",

            '13': "OK, let’s roll up our socks! We’ll have to get busy if we want to put the whole collection together.",
            '13:1': "I don’t spend much time with human beings,</br>and I’d like to understand their emotions.",
            '14': "Can you explain to me how you feel when you look at an artwork?</br>Let’s try with this funny portrait hanging in the attic.", 

            // 'grenier:2

            '15': "From among the Enki faces, drag over the one that represents the emotion you feel when you look at this artwork.",
            
            // 'defi2:1 => Que ressens-tu devant ce portrait ?
            
            '16': "Oh, there seems to be something happening with the codex!</br>I haven’t told you everything about this valuable <strong>artefact</strong>.",
            '17': "When you stop and look at an artwork, the codex analyzes it and creates a sticker inspired by it. Isn’t that amazing?",
            '18': "Let’s use the power of the codex on two more portraits. Go back to the gallery and choose an artwork you like.",
          
            // 'tunnel:1 :
            
            '19': "I love playing along with you! Finding out your emotions when you look at these artworks lets me see them differently.",

            // 'explore:3
            // 'defi2:2 => Que ressens-tu devant ce portrait ?

            '20': "What you’re expressing to me is fascinating! Human beings are truly</br>my favourite creatures!",

            // '[SÉPARATION] ?

            '21': "These portraits show us how very different all human beings are.</br>It impresses me each time! Let’s play together again.",
            '22': "This time, choose the artwork that you find most surprising.",

            // 'explore:4
            // 'defi2:3 => Que ressens-tu devant ce portrait ?

            '23': "I’m learning a lot thanks to you, and I’d like to tell you a bit more about me.",
            '24': "I’m the one who assembled this collection of artworks. I’ve always been fascinated with the human species, and so I gave myself a challenge ...",
            '25': "Gather portraits so I can understand you human beings better.",  

            // '[SÉPARATION] ?
  
            '26': "To tell the truth, the last artwork, the one we want to find, doesn’t exist. Well, not yet! Let me explain.",
            '27': "Human beings are so different from each other that I was never able to decide about the last portrait in my collection.",

            '30' : "With your help, I’ll be able to complete my work. Because you’ve proved to me that you can see and feel things in a unique way, what would you say about creating the final artwork in the gallery?",

            '31' : "Create your own portrait: you can portray yourself or portray someone else.",
            '32' : "Use the codex to select the customization options inspired by the artworks. Let your imagination run free and surprise Enki with your creation!",
            '33' : "Wow, you’re very talented!</br>Look how magnificent your artwork is!",

            'merci' : "Bravo! You made it possible for me to understand you human beings better. Having you with me was a very big help!</br>Thank you so much!",
            '35' : "Now it’s my turn to show you the mysteries of my species. I’d like to make you a gift of the Vision of Spirits.",

            // '36' : "Voici le monde tel que les esprits le voient ! Impressionnant, non ?",
            // '37' : "Ouf, quelle aventure ! [Enki bâille.] Notre quête est maintenant terminée, j'ai bien mérité un peu de repos. Avant de partir, prends le temps d'écouter les commentaires que j'ai glissés près des œuvres. Et reviens me voir quand tu veux, ma galerie est maintenant la tienne. Bon, c'est l'heure de la sieste…",
        
        },
        btn: {
            ok: 'Ok',
            deposer: 'Slide',
            rendre: 'Give the camera back to Nour.',
            pickup: 'Collect',
            download: 'Download',
            continue: 'Continue',
            start_experience: 'Continue',
            start: 'Start',
            help: 'Help Nour',
            skip: 'SKIP',
            completed: "I’m finished",
            listen: 'Listen',
            read: 'Read',
            close: 'Close',
            pause: 'Pause',
            world_call: 'WORLD 3D CALL OR NOT NEEDED',
            commentary: 'Commentary'
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/commons/lang/GlobalLang.js